export default {"src":"/_next/static/media/partner25.f9d804a1.svg","height":84,"width":149,"blurWidth":0,"blurHeight":0};